import {FormGroup} from '@angular/forms';
import { PaymentPlanPreview } from './payment-plan-preview.model';
import { PaymentTerm } from './payment-term.model';

export class PaymentTermForm {
  payment_dates: any[];
  selected_term_id: string;
  selected_term_name: string;
  customer_service_fee: string;
  initial_payment_amount: string;
  valid: boolean;

  constructor(form: FormGroup, paymentTerm: PaymentTerm, paymentPlanData: PaymentPlanPreview, isApplied?: boolean) {
    if (form) {
      const customDates = form.value.customDates;
      this.payment_dates = customDates ? customDates : this.paymentDueDates(paymentPlanData);
      this.selected_term_id = form.value.paymentTermSelect;
      this.initial_payment_amount = paymentPlanData ? paymentPlanData.initial_payment_amount : null;
      this.selected_term_name = paymentTerm ? paymentTerm.name : null;
      this.customer_service_fee = paymentPlanData ? paymentPlanData.customer_service_fee : null;
      this.valid = isApplied === false ||  form.status === 'INVALID' ? false : true;
    }
  }

  paymentDueDates(paymentPlanData: PaymentPlanPreview): Array<string> {
    if (paymentPlanData) {
      return paymentPlanData.payments.map((payment) => {
        if (!payment.upfront_payment) { return payment.due_date; }
      }).filter(date => !!date);
    }
  }
}
